import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/stockReceipt`;
const stockreceiptsuggestions = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/stocksItem/stockLine`;
export const stockReceiptService = {
  getAll,
  search,
  searchByView,
  getSuggestion,
  getById,
  getViewById,
  update,
  updateStatus,
  getByOrderId,
  create,
  createViaJobTask,
  uploadAsyCudaFile,
  getAsycuda,
  getHistory,
  getDocuments,
  getTransactions,
  printPdf,
  exportExcel,
  downloadExcelStockDetails,
  delete: _delete,
  downloadCsvStockDetails,
  deleteLine,
  deleteLineItem,
  uploadSummaryReceipt,
  manualAdd,
  getSuggestionNew,
  updateReceiptLine,
  sendMail,
  stockReceiptAvailability,
  dispose,
  stockReceiptAvailabilitySearch,
  exportExcelOfAvialableLiability,
  getStockReceiptByPurchaseOrderId,
};

function getAll() {
  return fetchWrapper.get(baseUrl);
}

function search(params) {
  return fetchWrapper.get(`${baseUrl}/stockReceiptSearch${params}`);
}

function searchByView(params) {
  return fetchWrapper.get(`${baseUrl}/stockReceiptSearch${params}`);
}

function getSuggestion(params) {
  return fetchWrapper.get(`${baseUrl}/suggestion${params}`);
}

function getById(id) {
  return fetchWrapper.get(`${baseUrl}/${id}`);
}

function getViewById(id) {
  return fetchWrapper.get(`${baseUrl}/stockReceiptView/${id}`);
}

function update(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

function updateReceiptLine(receiptId, lineId, params) {
  return fetchWrapper.put(`${baseUrl}/${receiptId}/line/${lineId}`, params);
}

function updateStatus(id, params) {
  return fetchWrapper.put(`${baseUrl}/${id}/updateStatus`, params);
}

function getByOrderId(id) {
  return fetchWrapper.get(`${baseUrl}/stockReceiptView/${id}`);
}

function create(params) {
  return fetchWrapper.post(baseUrl, params);
}

function createViaJobTask(params) {
  return fetchWrapper.post(`${baseUrl}/productOutput`, params);
}

function uploadAsyCudaFile(params) {
  return fetchWrapper.post(`${baseUrl}/asycuda`, params);
}

function getAsycuda(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/asycuda`);
}

function getHistory(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/history`);
}

function getDocuments(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/document`);
}

function getTransactions(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/transaction`);
}

function _delete(id) {
  return fetchWrapper.delete(`${baseUrl}/${id}`);
}

function deleteLine(id, lineId) {
  return fetchWrapper.delete(`${baseUrl}/${id}/line/${lineId}`);
}

function downloadExcelStockDetails(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/excel-stock-info`, {
    responseType: "blob",
  });
}
function deleteLineItem(id, stockItemId) {
  return fetchWrapper.delete(`${baseUrl}/${id}/lineItem/${stockItemId}`);
}

function exportExcel(params) {
  return fetchWrapper.get(`${baseUrl}/export-excel${params}`, {
    responseType: "blob",
  });
}

function uploadSummaryReceipt(params) {
  return fetchWrapper.post(`${baseUrl}/uploadSummary`, params);
}

function printPdf(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/printPdf`, {
    responseType: "blob",
  });
}

function downloadCsvStockDetails(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/csv-stock-info`, {
    responseType: "blob",
  });
}

function manualAdd(params) {
  return fetchWrapper.post(`${baseUrl}/manual`, params);
}

function getSuggestionNew(id, params) {
  return fetchWrapper.get(`${stockreceiptsuggestions}/${id}${params}`);
}

function sendMail(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/send-mail`);
}

function stockReceiptAvailability() {
  return fetchWrapper.get(`${baseUrl}/stockReceiptWiseAvailable`);
}

function stockReceiptAvailabilitySearch(params) {
  return fetchWrapper.get(`${baseUrl}/stockReceiptWiseAvailable${params}`);
}

function dispose(stockReceiptId, params) {
  return fetchWrapper.put(
    `${baseUrl}/stockReceiptItemDispose/${stockReceiptId}`,
    params
  );
}

function exportExcelOfAvialableLiability(params) {
  return fetchWrapper.get(
    `${baseUrl}/stockReceiptWiseAvailable/export-excel${params}`,
    {
      responseType: "blob",
    }
  );
}

function getStockReceiptByPurchaseOrderId(id) {
  return fetchWrapper.get(`${baseUrl}/purchaseOrder/${id}`);
}
